/* eslint-disable */
/**
 * TikTok Pixel Integration Helper
 * Supports dynamic Pixel ID via URL param ?tt=123123123 or localStorage
 */

export const getTikTokId = () => {
  try {
    // 1. Check window.location.search
    let params = new URLSearchParams(window.location.search);
    let tt = params.get('tt');

    // 2. Check window.location.hash if present
    if (!tt && window.location.hash.includes('?')) {
      const hashQuery = window.location.hash.split('?')[1];
      const hashParams = new URLSearchParams(hashQuery);
      tt = hashParams.get('tt');
    }

    // 3. Fallback to localStorage
    if (tt) {
      localStorage.setItem('pixel_tt', tt);
      return tt;
    }
    return localStorage.getItem('pixel_tt') || null;
  } catch (e) {
    return localStorage.getItem('pixel_tt') || null;
  }
};

export const initTikTokPixel = (explicitId) => {
  const pixelId = explicitId || getTikTokId();
  if (!pixelId) {
    console.log('[TikTok Pixel] No TT ID found yet');
    return null;
  }

  // Inject TikTok base code if not already present
  if (!window.ttq) {
    (function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = (w[t] = w[t] || []);
      ttq.methods = [
        "page",
        "track",
        "identify",
        "instances",
        "debug",
        "on",
        "off",
        "once",
        "ready",
        "alias",
        "group",
        "enableCookie",
        "disableCookie",
        "holdConsent",
        "revokeConsent",
        "grantConsent",
      ];
      ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
          ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      };
      ttq.load = function (e, n) {
        var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
        var o = n && n.partner;
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = r;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = r + "?sdkid=" + e + "&lib=" + t;
        var firstScript = document.getElementsByTagName("script")[0];
        if (firstScript && firstScript.parentNode) {
          firstScript.parentNode.insertBefore(s, firstScript);
        } else {
          document.head.appendChild(s);
        }
      };
    })(window, document, "ttq");
  }

  try {
    if (window.ttq && window.ttq.load) {
      window.ttq.load(pixelId);
      window.ttq.page();
      console.log('[TikTok Pixel] Initialized with ID:', pixelId);
    }
  } catch (err) {
    console.error('[TikTok Pixel] Load error:', err);
  }

  return pixelId;
};

export const trackTikTokEvent = (eventName, params = {}) => {
  try {
    // Ensure pixel initialized
    if (!window.ttq) {
      initTikTokPixel();
    }
    if (window.ttq && typeof window.ttq.track === 'function') {
      window.ttq.track(eventName, params);
      console.log('[TikTok Pixel] Tracked event:', eventName, params);
    }
  } catch (err) {
    console.error('[TikTok Pixel] Track error for', eventName, err);
  }
};

export default {
  getTikTokId,
  initTikTokPixel,
  trackTikTokEvent,
};
